import { useGetEnvironment } from 'commons/customHooks'

import * as S from './styles'

export type Environment = 'Dev' | 'Teste'

export const EnvironmentTag = () => {
  const { isDevelopment, isProduction } = useGetEnvironment()
  const environment = isDevelopment ? 'Dev' : 'Teste'

  if (isProduction) {
    return null
  }

  return (
    <S.Container>
      <S.Dot environment={environment} />
      <S.Text environment={environment}>Ambiente de {environment}</S.Text>
    </S.Container>
  )
}
